import { ProductResponse, ViewTrolleyProductListGroup } from '@woolworthsnz/trader-api';

/**
 * Extended ProductResponse type that includes additional fields
 * ProductResponse from API may include these fields even though not in type definition
 */
export type ProductWithRestrictedInfo = ProductResponse & {
	isTobaccoProduct?: boolean;
	isAlcoholProduct?: boolean;
};

/**
 * Checks if a product is a restricted item (tobacco or alcohol)
 * Uses explicit isTobaccoProduct or isAlcoholProduct flags
 * Restricted items include alcohol and tobacco products
 */
export const isRestrictedItem = (product?: ProductResponse): boolean => {
	const productWithInfo = product as ProductWithRestrictedInfo;
	return productWithInfo?.isTobaccoProduct === true || productWithInfo?.isAlcoholProduct === true;
};

/**
 * Checks if any products in the trolley categories are restricted items
 */
export const hasRestrictedItemsInTrolley = (items?: ViewTrolleyProductListGroup[]): boolean => {
	if (!items || items.length === 0) {
		return false;
	}

	return items.some((category: ViewTrolleyProductListGroup) =>
		category.products?.some((product: ProductResponse) => isRestrictedItem(product))
	);
};
